import {DatePicker, type UseDatePickerContext} from '@ark-ui/react/date-picker';
import {Button, Flex} from '@chakra-ui/react';
import {faChevronLeft} from '@fortawesome/pro-duotone-svg-icons/faChevronLeft';
import {faChevronRight} from '@fortawesome/pro-duotone-svg-icons/faChevronRight';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconButton} from '../IconButton';

const DateViewPicker = ({api}: {api: UseDatePickerContext}) => {
  return (
    // TODO https://linear.app/linxsecurity/issue/PRE-771/create-custom-date-picker-dropdown
    <Flex justifyContent={`space-between`} alignItems={`middle`}>
      <DatePicker.PrevTrigger asChild>
        <IconButton
          aria-label={`Next month`}
          variant={`unstyled`}
          icon={<FontAwesomeIcon icon={faChevronLeft} />}
          sx={{
            margin: `2`,
            padding: `4`,
            height: `auto`,
            minHeight: `16`,
            width: `auto`,
            minWidth: `16`,
            fontSize: `sm`,
            _hover: {
              backgroundColor: `blackAlpha.100`,
            },
          }}
        />
      </DatePicker.PrevTrigger>

      <Button
        variant={`unstyled`}
        sx={{
          fontSize: `sm`,
          fontWeight: `semibold`,
          display: `flex`,
          alignItems: `center`,
          cursor: `default`,
        }}
        onClick={() => (api.view === `day` ? api.setView(`month`) : api.setView(`day`))}>
        <DatePicker.RangeText />
      </Button>

      <DatePicker.NextTrigger asChild>
        <IconButton
          aria-label={`Next month`}
          variant={`unstyled`}
          icon={<FontAwesomeIcon icon={faChevronRight} />}
          sx={{
            margin: `2`,
            padding: `4`,
            height: `auto`,
            minHeight: `16`,
            width: `auto`,
            minWidth: `16`,
            fontSize: `sm`,
            _hover: {
              backgroundColor: `blackAlpha.100`,
            },
          }}
        />
      </DatePicker.NextTrigger>
    </Flex>
  );
};

export default DateViewPicker;
